import { toRef, computed } from 'vue'
import { useNotificationStore } from '@/stores'

const byCreatedAt = (a, b) => (a.createdAt?.getTime() ?? 0) - (b.createdAt?.getTime() ?? 0)

export default ({ items, checkedNotificationIds }) => {
  const selectedNotificationId = toRef(useNotificationStore(), 'selectedNotificationId')

  const countAll = computed(() => items.value.length)
  const countRead = computed(() => items.value.filter(n => !!n.readAt).length)
  const countUnread = computed(() => items.value.filter(n => !n.readAt).length)
  const unreadNotifications = computed(() => items.value.filter(n => !n.readAt).sort(byCreatedAt))
  const readNotifications = computed(() => items.value.filter(n => !!n.readAt).sort(byCreatedAt))
  const allNotificationsSorted = computed(() =>
    [...items.value].sort((a, b) => {
      const d = byCreatedAt(a, b)
      return d !== 0 ? d : (b.readAt ? 1 : 0) - (a.readAt ? 1 : 0)
    })
  )
  const selectedNotification = computed(() => allNotificationsSorted.value.find(n => n.id === selectedNotificationId.value) ?? null)
  const checkedNotificationsCount = computed(() => checkedNotificationIds.value.size)
  const hasCheckedNotifications = computed(() => checkedNotificationIds.value.size > 0)

  return {
    countAll,
    countRead,
    countUnread,
    unreadNotifications,
    readNotifications,
    allNotificationsSorted,
    selectedNotification,
    checkedNotificationsCount,
    hasCheckedNotifications
  }
}
